import React from "react";

import "react-circular-progressbar/dist/styles.css";
import 'react-tooltip/dist/react-tooltip.css'
import SkillsBar from '../api/skills.json';
import CiruclarBarImage from "./inc/CiruclarBarImage";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Tooltip as ReactTooltip } from 'react-tooltip'
 
import { useInView } from 'react-intersection-observer';
import { shuffledData } from "../utils/constant";
const Skills = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // const skills = [
  //   { name: 'HTML', icon: '🌐' },
  //   { name: 'CSS', icon: '🎨' },
  //   { name: 'JavaScript', icon: '🟨' },
  //   { name: 'React', icon: '⚛️' },
  //   { name: 'Node.js', icon: '🟩' },
  //   { name: 'MongoDB', icon: '🍃' },
  //   { name: 'Git', icon: '🔧' },
  //   { name: 'Figma', icon: '🎯' },
  // ];

  // console.log(SkillsBar);
  return (
    <>
      <div className="skills-section">
        <div className="container">
          <div className="row">
            <div className="skill-text-column col-lg-12">
              <div className="text-align-center">
                <h2 className="section-heading">Skills 🔥</h2>
              </div>
            </div>
          </div>
        </div>


        <div className="container py-5"> 
      <div className="slider-container">
      <Slider {...settings}>
          {shuffledData(SkillsBar).map((skill, index) => (
            <SkillCard skill={skill} key={index} />
          ))}
        </Slider>
      </div>
    </div>
       
       
        {/* <div className="row" style={{margin:"10px",rowGap:'50px'}}> */}
        {/* value,toolkit,altDes,imgUri 
        
        "id":1,
        "tooltip":"React",
        "alt":"React",
        "url":"./media/react.svg",
        "percent":80
        */}
        {/* {SkillsBar.map((e,i,arr)=>{
            return <CiruclarBarImage key={i} value={e.percent} toolkit={e.tooltip} altDes={e.alt} imgUri={e.url} />
        })} */}


          {/* <div className="col-lg-2 col-sm-4 col-6">
          <div className="skill-wrapper">
          <div className="single-skill">
           <CircularProgressbarWithChildren strokeWidth={5} value={66}>
        <img
        data-tooltip-content="Api"
        id="my-element"
        className="skill-icon"
          src="./media/api.dfa7afca97451dea786b1c8395dbf6ff.svg"
          alt="img"

        />
       
        <ReactTooltip anchorId="my-element" />
        <div style={{ fontSize: 12, marginTop: -5 }}>
        </div>
      </CircularProgressbarWithChildren>

            </div>
          </div>
          </div> */}
        {/* </div> */}
      </div>
    </>
  );
};

export default Skills;


const SkillCard = ({ skill }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  return (
    <div ref={ref} className="text-center p-3 ">
      <div
      className=""
        style={{
          border: '.2px solid #ccc',
          borderRadius: '12px',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          boxShadow: '0 4px 8px rgba(177, 177, 177, 0.1)',
        }}
      >
        <div style={{ fontSize: '2rem' }}>
          <img
            data-tooltip-content={skill.tooltip}
            id={skill.alt}
            className="skill-icon-img"
            src={skill.url}
            alt={skill.alt}
          />
          {/* <ReactTooltip anchorId={skill.alt} /> */}
        </div>
        <h5 className="mt-3" style={{textTransform:'capitalize'}}>{skill.alt}</h5>

        {/* Animated Progress Bar */}
        <div className="progress-wrapper mt-3">
          <div className="progress-bar-bg">
            <div
              className="progress-bar-fill"
              style={{
                width: inView ? `${skill.percent}%` : '0%',
                transition: 'width 1s ease-in-out',
              }}
            ></div>
          </div>
          <div className="progress-text">{skill.percent}%</div>
        </div>
      </div>
    </div>
  );
};
